import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = {
  // Company Information
  getCompanyInfo: async () => {
    try {
      const response = await axios.get(`${API}/company`);
      return response.data;
    } catch (error) {
      console.error('Error fetching company info:', error);
      throw error;
    }
  },

  // Services
  getServices: async () => {
    try {
      const response = await axios.get(`${API}/services`);
      return response.data;
    } catch (error) {
      console.error('Error fetching services:', error);
      throw error;
    }
  },

  // Projects
  getProjects: async () => {
    try {
      const response = await axios.get(`${API}/projects`);
      return response.data;
    } catch (error) {
      console.error('Error fetching projects:', error);
      throw error;
    }
  },

  // Leadership Team
  getTeam: async () => {
    try {
      const response = await axios.get(`${API}/team`);
      return response.data;
    } catch (error) {
      console.error('Error fetching team:', error);
      throw error;
    }
  },

  // Core Values
  getValues: async () => {
    try {
      const response = await axios.get(`${API}/values`);
      return response.data;
    } catch (error) {
      console.error('Error fetching values:', error);
      throw error;
    }
  },

  // Contact Form Submission
  submitContactForm: async (formData) => {
    try {
      const response = await axios.post(`${API}/contact`, formData);
      return response.data;
    } catch (error) {
      console.error('Error submitting contact form:', error);
      throw error;
    }
  }
};
